document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.sg-header');
  const button = document.querySelector('[data-sg-menu]');
  if (!header || !button) return;
  button.addEventListener('click', function () {
    const open = header.classList.toggle('sg-menu-open');
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    button.textContent = open ? '×' : '☰';
  });
  header.querySelectorAll('.sg-nav a').forEach(function (link) {
    link.addEventListener('click', function () {
      header.classList.remove('sg-menu-open');
      button.setAttribute('aria-expanded', 'false');
      button.textContent = '☰';
    });
  });
});
